import { InputsModel } from './inputs.model';
import {BaseModel} from './base.model';

export class FormularioModel implements BaseModel {
  form: string;
  inputs: InputsModel[] = [];
}
